/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import createPersistedState from "vuex-persistedstate";
import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import SecureLS from "secure-ls";
var ls = new SecureLS({ isCompression: false });
Vue.use(Vuex);

// import moduleTodo from './todo/moduleTodo.js'
// import moduleCalendar from './calendar/moduleCalendar.js'
// import moduleChat from './chat/moduleChat.js'
// import moduleEmail from './email/moduleEmail.js'
import moduleECommerce from "./eCommerce/moduleECommerce.js";
import moduleSmsCampaign from "./smsCampaign";
import moduleManageUser from "./manageUser";
import modulePushNotification from "./pushNotification";
import moduleStudio from "./studio";
import moduleSegment from "./segment";
import moduleAudience from "./audience";
import moduleAdmin from "./Admin";
import moduleUser from "./user/moduleUser.js";
import modelScope from "./Scope/index";
import moduleBrand from "./brand";
import moduleBrandProfile from "./brandProfile";
import moduleDesign from "./design";
import moduleUtilities from "./utilities";
import moduleNotification from "./notification";
import moduleBilling from "./Billing";
import Errorcodes from "./error_mgmt";
import moduleTags from "./Tags/Index";
import moduleEcomCategory from "./EcomCategory/Index";
import moduleEcomAttributes from "./EcomAttributes/Index";
import studio from "./studio";
import moduleEcomProduct from "./EcomProduct/Index";
import CmsMenu from "./CmsMenu/Index";
import moduleEcomVariation from "./EcomVariation/Index";
import emailModule from "./email/index";
import moduleBuilder from "./builder/index";
import whatsApp from "./whatsApp";
import landingPage from "./landingPage/index";
import EcomOrder from "./EcomOrder/Index";
import template from "./Template/index";
import campaign from "./campaign";
import Extensions from "./extensions/index";
import blogs from "./blogs";
import AdminPages from "./adminPages";
import twoHerMenu from "./twoHerMenu/Index";
import threeHerMenu from "./threeHerMenu/Index";
import DNS from "./DNS/Index";
import RSU from "./RSU/Index";
import logs from "./logs/Index";
import Transaction from "./Transaction/Index";
import Payment from "./Payment/Index";
import controlCenter from "./controlCenter/index";
import EcomCoupon from "./EcomCoupon/Index";
// import AgentRouting from "./AgentRouting/Index";
import EcomReview from "./EcomReview/Index";
import marcom from "./Marcom";
import variation from "./variation";
import Errormanagment from "./Errormanagment/Index";
import AgentRouting from "./AgentRouting/Index";
import eLearningAuthor from "./eLearningAuthor/index";
import eLearningCategory from "./eLearningCategory/index";
import eLearningCourse from "./eLearningCourse/index";
import elearningchapter from "./eLearningChapter/index";
import elearningtopic from "./ElearningTopic/index";
import defaultTemplates from "./defaultTemplates";
import IntellectualProperty from "./IntellectualProperty";
import portfolioTestimonial from "./portfolioTestimonial/Index";
import portfolioCategory from "./portfolioCategory/Index";
import portfolioSubcategory from "./portfolioSubcategory/Index";
import portfolioMgmt from "./portfolioMgmt/index";
import agreement from "./agreement";
import EcomOrderReturn from "./EcomOrderReturn/Index";
import modules from "./Modules";
import projectFile from "./project/index";
import issueTracker from "./issueTracker/index";
import getNotify from "./getNotifications/index";
import menu from "./menu2.O/Index";
import WebsitePayload from "./WebsitePayload";
import Seo from "./Seo";
import logsForPagesRoles from './logsForPagesRoles/index';
import baseAdminCategory from "./baseAdminCategory/index.js";

import variable from "./variable";
let initialState = {
  // todo: moduleTodo,
  // calendar: moduleCalendar,
  // chat: moduleChat,
  // email: moduleEmail,

  eCommerce: moduleECommerce,
  smsCampaign: moduleSmsCampaign,
  manageUser: moduleManageUser,
  pushNotification: modulePushNotification,
  studio: moduleStudio,
  segment: moduleSegment,
  audience: moduleAudience,
  admin: moduleAdmin,
  brand: moduleBrand,
  user: moduleUser,
  design: moduleDesign,
  utilities: moduleUtilities,
  notification: moduleNotification,
  brandProfile: moduleBrandProfile,
  billing: moduleBilling,
  scope: modelScope,
  errorcodes: Errorcodes,
  studio: studio,
  tags: moduleTags,
  EcomCategory: moduleEcomCategory,
  // EcomAttributes: moduleEcomAttributes,
  EcomProduct: moduleEcomProduct,
  EcomAttributes: moduleEcomAttributes,
  whatsApp: whatsApp,
  CmsMenu: CmsMenu,
  EcomVariation: moduleEcomVariation,
  email: emailModule,
  builder: moduleBuilder,
  template: template,
  campaign: campaign,
  landingPage,
  EcomOrder,
  Extensions: Extensions,
  blogs,
  AdminPages,
  twoHerMenu,
  threeHerMenu,
  DNS,
  RSU,
  logs,
  Transaction,
  Payment,
  controlCenter,
  EcomCoupon,
  AgentRouting,
  EcomReview,
  marcom,
  variation: variation,
  Errormanagment,
  eLearningAuthor: eLearningAuthor,
  eLearningCategory: eLearningCategory,
  eLearningCourse: eLearningCourse,
  elearningchapter,
  defaultTemplates: defaultTemplates,
  elearningtopic,
  IntellectualProperty,
  Seo,
  portfolioTestimonial,
  portfolioCategory,
  portfolioSubcategory,
  portfolioMgmt,
  agreement,
  EcomOrderReturn,
  modules,
  projectFile: projectFile,
  issueTracker: issueTracker,
  getNotify: getNotify,
  menu,
  WebsitePayload,
  logsForPagesRoles,
  variable,
  baseAdminCategory
};

export default new Vuex.Store({
  getters,
  mutations: {
    ...mutations,
    RESET_STATE(state) {
      Object.keys(initialState).forEach((element, index) => {
        console.log(
          state[element],
          element,
          initialState[element].state,
          "STATE"
        );
        Object.assign(state[element], initialState[element].state);
        // state[element] = state.initialState[element];
      });
    },
  },
  state,
  actions,
  modules: {
    // todo: moduleTodo,
    // calendar: moduleCalendar,
    // chat: moduleChat,
    // email: moduleEmail,
    // auth: moduleAuth,
    eCommerce: moduleECommerce,
    smsCampaign: moduleSmsCampaign,
    manageUser: moduleManageUser,
    pushNotification: modulePushNotification,
    studio: moduleStudio,
    segment: moduleSegment,
    audience: moduleAudience,
    admin: moduleAdmin,
    brand: moduleBrand,
    scope: modelScope,
    user: moduleUser,
    design: moduleDesign,
    utilities: moduleUtilities,
    notification: moduleNotification,
  },
  modules: initialState,
  strict: process.env.NODE_ENV !== "production",
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});
